import Vue from 'vue'
import axios from 'axios'
import vSelect from 'vue-select';
//import Vuetify from 'vuetify';
window.Vue = Vue;

Vue.component('podsearch', require('./components/PodSearch.vue').default);
Vue.component("v-select", vSelect);
//Vue.use(Vuetify);
const app = new Vue({
    el: '#podsearch',
    //vuetify : new Vuetify()
});
